// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__ZnSAL","footer":"ModalError_footer__3mVMn"};